/** Fields shown on create/edit giveaway campaign — excludes rulesText, etc. */
const CAMPAIGN_FORM_FIELDS = [
  'title',
  'slugMonth',
  'bannerImage',
  'shoesImage',
  'selectionDateUtc',
  'status',
  'winnerCount',
];

export function omitRulesText(data) {
  if (!data || typeof data !== 'object') return data;
  const { rulesText, ...rest } = data;
  return rest;
}

/** Strip rules from GET /giveaway/current and nested campaign payloads. */
export function sanitizeGiveawayState(state) {
  if (!state || typeof state !== 'object') return state;
  const next = omitRulesText(state);
  if (next.campaign) next.campaign = omitRulesText(next.campaign);
  return next;
}

export function pickCampaignFormValues(data) {
  if (!data || typeof data !== 'object') return {};
  const out = {};
  CAMPAIGN_FORM_FIELDS.forEach((key) => {
    if (data[key] !== undefined) out[key] = data[key];
  });
  // Prefer winnerCount; fall back to requiredWinnerCount for older payloads.
  if (out.winnerCount === undefined || out.winnerCount === null || out.winnerCount === '') {
    const fallback = data.requiredWinnerCount;
    if (fallback !== undefined && fallback !== null && fallback !== '') {
      out.winnerCount = fallback;
    }
  }
  if (out.winnerCount !== undefined && out.winnerCount !== null && out.winnerCount !== '') {
    const n = Number(out.winnerCount);
    if (Number.isFinite(n)) out.winnerCount = n;
  }
  return out;
}

/**
 * Build multipart body for POST/PATCH /admin/giveaway/campaigns.
 * shoesImage is appended only when it is a File; existing URL strings are omitted
 * so the server keeps the previously uploaded path.
 */
export function buildCampaignFormData(payload) {
  const formData = new FormData();
  if (!payload || typeof payload !== 'object') return formData;

  Object.keys(payload).forEach((key) => {
    const value = payload[key];
    if (value === undefined || value === null || value === '') return;

    if (key === 'shoesImage') {
      if (typeof File !== 'undefined' && value instanceof File) {
        formData.append('shoesImage', value, value.name);
      }
      return;
    }

    formData.append(key, String(value));
  });

  return formData;
}
